define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");
    var LEResourceResolver = require("leResourceResolver");

    var TicketListExportModel = {};
    LE.module("LEContent", function () {

        TicketListExportModel = BaseModel.extend({
            resource: ApiResources.ConnectionPanelDownload.CaseExport,

            initialize: function (options) {
                options = options || {};
                //var isUsersWithProfiles = LE.sessionManager.hasProfilesFeature(); // check permission accordingly=
                var fileName = options.fileName;
                this.resource.url = this.resource.url.replace("{fileName}", fileName);
                this.resource.url = LEResourceResolver.getUrl(this.resource.url);
            },
            name: "TicketListExportModel"
        });
    });
    return TicketListExportModel;
});
